import { inject, Injectable } from '@angular/core';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { catchError, map, Observable, of } from 'rxjs';

export const IOT_PLATFORM_INDEXED_DB_STORE = 'iot-platform-kv-store';

@Injectable({
  providedIn: 'root'
})
export class IndexedDbService {
  private readonly dbService: NgxIndexedDBService = inject(NgxIndexedDBService);
  private readonly storeName = IOT_PLATFORM_INDEXED_DB_STORE;

  get<T = string>(key: string): Observable<T | null> {
    return this.dbService.getByKey<{ key: string; value: T }>(this.storeName, key).pipe(
      map((record) => record?.value ?? null),
      catchError(() => of(null))
    );
  }

  set<T = string>(key: string, value: T): Observable<void> {
    return this.dbService.update(this.storeName, { key, value }).pipe(
      map(() => void 0),
      catchError(() => of(void 0))
    );
  }

  remove(key: string): Observable<void> {
    return this.dbService.deleteByKey(this.storeName, key).pipe(catchError(() => of(void 0)));
  }

  clear(): Observable<void> {
    return this.dbService.clear(this.storeName).pipe(catchError(() => of(void 0)));
  }
}

